import React from 'react';

const SIZE_CLASSES = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
  '2xl': 'h-16 w-16',
  hero: 'h-[72px] w-[72px]'
};

/**
 * Shared Logami loading spinner used across the app for consistent loading UI.
 */
export default function LogamiLogoSpinner({
  size = 'lg',
  className = '',
  alt = 'Logami loading',
  decorative = true,
  src = '/logo-icon.png?v=1'
}) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.lg;
  const altText = decorative ? '' : alt;

  return (
    <img
      src={src}
      alt={altText}
      aria-hidden={decorative ? 'true' : undefined}
      draggable="false"
      className={`${sizeClass} animate-spin motion-reduce:animate-none ${className}`.trim()}
    />
  );
}
